
export function numeral(count: number, one:  string, two: string, five?: string){
	if(!count) count = 0;
	//десять-девятнадцать
	if(count%100/10>>0 === 1)
		return five || two;
	//ноль, пять-девять
	if(count%10 >= 5 || count%10===0)
		return five || two;
	//один
	if(count%10 === 1)
		return one;

	//две-четыре
	return two;
}

export function num(count: number, one:  string, two:  string, five:  string){
	return count + " " + numeral(count, one, two, five)
}

export function increment(str: string, exclude?: string[]) {
	const match = str.match(/\d+$/)
	if (match) {
		const i = (parseInt(str.slice(match.index)) || 0) + 1
		const start = str.slice(0, match.index)
		for (let j = 0; j < 100; j++) {
			if (!exclude?.find(str => str === start + (i + j)))
			return start + (i + j)
		}
	}
	return str + " 1"
}

export function toOne(str: string) {
	if (!str) return ""
	
	if (str.endsWith('ли') || str.endsWith('ти') || str.endsWith('ди')) {
		return str.slice(0, -1) + 'ь'
	}

	if (['ки', 'шы'].find(end => str.endsWith(end))) {
		return str.slice(0, -1) + 'a'
	}
	if (str.endsWith('и') || str.endsWith('ы') || str.endsWith('s')) {
		return str.slice(0, -1)
	}

	if (str.endsWith('я')) {
		return str.slice(0, -1) + 'е'
	}

	return str
}